/**
 * @generated SignedSource<<f88efb18e44a6eda999a3ec637b64dbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type viewerStructureSection_ViewerIframeQuery$variables = {
  id: string;
};
export type viewerStructureSection_ViewerIframeQuery$data = {
  readonly node: {
    readonly iframeUrl?: {
      readonly viewerUrl: string;
    };
    readonly modelID?: number;
  } | null;
};
export type viewerStructureSection_ViewerIframeQuery = {
  response: viewerStructureSection_ViewerIframeQuery$data;
  variables: viewerStructureSection_ViewerIframeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketplaceIframe",
      "kind": "LinkedField",
      "name": "iframeUrl",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "viewerStructureSection_ViewerIframeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewerStructureSection_ViewerIframeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "348f97ecb5b49055712cd4c1b679686d",
    "id": null,
    "metadata": {},
    "name": "viewerStructureSection_ViewerIframeQuery",
    "operationKind": "query",
    "text": "query viewerStructureSection_ViewerIframeQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      modelID\n      iframeUrl {\n        viewerUrl\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ca3f3c08025742c27f99fd71b2c7db8";

export default node;
